function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M 6 14 C 4.8954305 14 4 14.895431 4 16 C 4 17.104569 4.8954305 18 6 18 C 7.1045695 18 8 17.104569 8 16 C 8 14.895431 7.1045695 14 6 14 z M 16 14 C 14.895431 14 14 14.895431 14 16 C 14 17.104569 14.895431 18 16 18 C 17.104569 18 18 17.104569 18 16 C 18 14.895431 17.104569 14 16 14 z M 26 14 C 24.895431 14 24 14.895431 24 16 C 24 17.104569 24.895431 18 26 18 C 27.104569 18 28 17.104569 28 16 C 28 14.895431 27.104569 14 26 14 z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/load-more.93a221fe.svg";
export { SvgComponent as ReactComponent };